var React = require('react');

function PinSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M140.5 12.5c70 0 127 57 127 128 0 63-66 149-111 214-8 12-25 12-33 0-44-65-111-151-111-214 0-71 57-128 128-128zm0 85c23 0 42 19 42 43 0 23-19 42-42 42-24 0-43-19-43-42 0-24 19-43 43-43z","stroke":"#fff","strokeWidth":"25"}));
}

PinSolid.defaultProps = {"viewBox":"0 0 280 375.534","width":"280","height":"375.534"};

module.exports = PinSolid;

PinSolid.default = PinSolid;
